import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Checkbox, DialogActions, DialogContent, DialogTitle, ListItem, ListItemText } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog, CustomList } from '../../../components/StyledComponents';
import ExportDataDialog from '../UserManagement/ExportDataDialog';
import CustomDatePicker from './../../../components/CustomDatePicker';

const SelectDataToExportEventlogDialog = ({ idFilePassword, onClose }) => {
   const handleCloseDialog = () => {
      onClose();
   };

   const { t } = useTranslation();

   const [checkedItems, setCheckedItems] = useState({
      eventlog: true,
   });

   const [openExportSelectedEventlog, setOpenExportSelectedEventlog] = useState(false);

   const handleOpenExportSelectedEventlog = () => {
      setOpenExportSelectedEventlog(true);
   };

   const handleCloseExportSelectedEventlog = () => {
      setOpenExportSelectedEventlog(false);
   };

   const [exportEventsFromDate, setExportEventsFromDate] = useState(new Date());

   return (
      <Fragment>
         <CustomDialog open transitionDuration={300} maxWidth={'xl'} onClose={handleCloseDialog} keepMounted>
            <DialogTitle>
               <div className='flex justify-between'>
                  <div className='flex items-center gap-4'>

                     <p className='text-xl font-semibold '>Select data to export - EventLogs</p>
                  </div>
                  <GrayIconButton onClick={handleCloseDialog}>
                     <CloseIcon />
                  </GrayIconButton>
               </div>
            </DialogTitle>

            <DialogContent className='!py-0'>
               <div className='pt-5'>
                  <p>
                     Select the data you want to export. Selected data can be downloaded directly to your PC, or you can specify a FTP
                     location to save it.
                  </p>
                  <div className='flex flex-col'>
                     <CustomList>
                        <ListItem>
                           <Checkbox
                              checked={checkedItems.eventlog}
                              onChange={() => setCheckedItems({ ...checkedItems, eventlog: !checkedItems.eventlog })}
                           />
                           <ListItemText primary='Event logs' />
                        </ListItem>
                     </CustomList>
                     <div className='pl-10 flex flex-col gap-1'>
                        <p>Export events from this date</p>
                        <CustomDatePicker
                           name='exportEventsFromDate'
                           value={exportEventsFromDate}
                           onChange={(newDate) => setExportEventsFromDate(newDate)}
                           readOnly={true}
                        />
                     </div>
                  </div>
               </div>
            </DialogContent>

            <DialogActions>
               <div className='flex gap-2 px-4 py-4'>
                  <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                     <CloseIcon />
                     <p>{t('button.cancel')}</p>
                  </ControlpanelSecondaryButton>
                  <ControlpanelPrimaryButton onClick={handleOpenExportSelectedEventlog}>
                     <PlayArrowIcon />
                     <p>{t('button.start-export')}</p>
                  </ControlpanelPrimaryButton>
               </div>
            </DialogActions>
         </CustomDialog>

         {openExportSelectedEventlog && <ExportDataDialog onClose={handleCloseExportSelectedEventlog} passwordId={idFilePassword} />}
      </Fragment>
   );
};

export default SelectDataToExportEventlogDialog;
